import { render, staticRenderFns } from "./merchant-detail.vue?vue&type=template&id=5bc094c2&scoped=true&"
import script from "./merchant-detail.vue?vue&type=script&lang=ts&"
export * from "./merchant-detail.vue?vue&type=script&lang=ts&"
import style0 from "./merchant-detail.vue?vue&type=style&index=0&id=5bc094c2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc094c2",
  null
  
)

export default component.exports